// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.campaign-icons {
  height: 40px;
  width: 40px;
  cursor: pointer;
}
.campaign-details-parent-div {
  height: 80vh;
  overflow-y: auto;
}
.campaign-overview-links {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: 0.625rem;
  background: #fff;
  gap: 10px;
  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);
}

.recomended-products-div {
  min-height: 200px !important;
  max-height: 400px !important;
  overflow-y: scroll;
  padding-bottom: 16px;
  box-sizing: border-box;
}
.recommended-products {
  margin-top: 30px;
}
.campaign-more-actions-div {
  display: flex;
}
.campaign-details-page-display {
  display: flex;
  justify-content: space-between;
}

.my-billboards-tab .ant-segmented.ant-segmented-sm .ant-segmented-item-label {
  min-height: 20px;
  line-height: 20px;
  width: 236px;
}
.backarrow {
  cursor: pointer;
}

@media (width <= 1440px) {
  .campaign-icons {
    height: 28px;
    width: 28px;
  }
  .campaign-details-parent-div {
    height: 72vh;
    overflow-y: scroll;
  }
}

@media (width <= 1024px) {
  .campaign-icons {
    height: 32px;
    width: 32px;
  }
}
@media (width <= 430px) {
  .campaign-icons {
    height: 24px;
    width: 24px;
  }
  .middle-specification {
    border-radius: 0.5rem;
    align-items: center;
  }
  .my-billboards-tab {
    margin-top: 0rem;
    font-size: 12px;
    width: 400px;
    overflow-x: scroll;
  }
}
@media (width <= 380px) {
  .my-billboards-tab {
    margin-top: 0rem;
    font-size: 12px;
    width: 350px;
    overflow-x: scroll;
  }
}
@media (width <= 768px) {
  .campaign-overview-total-impressions {
    display: flex;
    flex-direction: row !important;
  }
}

.product-expired-conatiner {
  padding: 1.625rem 1.25rem 1.0625rem 1.25rem;
  gap: 1.25rem;
  border-radius: 0.625rem;
  background: #fff;
}
.expired-product-warning {
  color: var(--Colors-Text-500, #0a0f0d);
  font-family: Montserrat;
  font-size: var(--Font-Font-Size-h6, 1.1875rem);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.prodcts-expired {
  color: #000;
  text-align: center;
  font-family: Roboto;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  margin-top: 10px;
}
.prodcts-expired-names {
  font-family: Roboto;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  color: #000000;
}

.campaign-details-div {
  display: flex;
}

.campaign-details-page-display {
  width: 100%;
  margin: 0;
}

.campaign-details-io-div {
  gap: 1rem;
  display: flex;
}

.campaign-details-io-cancel-div {
  border-radius: 0.3125rem;
  background: #f5f5f5;
  width: 2.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  cursor: pointer;
}

.product-expired-conatiner-row {
  display: flex;
  justify-content: center;
  align-items: center;
}
.re-designed-campaign-details-parent-div {
  width: 85% !important;
}
.re-campaign-overview-alignment-container {
  display: flex;
  width: 15% !important;
  gap: 20px !important;
  flex-direction: column !important;
}
.my-billboards-tab .ant-segmented.ant-segmented-sm .ant-segmented-item-label {
  min-height: 20px;
  line-height: 20px;
  width: 236px;
  white-space: nowrap;
}
.campaign-segments.ant-segmented .ant-segmented-item-selected {
  background: var(--Icon-Default-Default, #ffffff) !important;
  border-radius: 10px !important;
  opacity: 1;
  border-width: 1px !important;
  border: 1px solid #e5e7eb !important;
  box-shadow: 0px 1px 2px -1px #0000001a;
  box-shadow: 0px 1px 3px 0px #0000001a;
  display: flex;
  align-items: center;
}
.campaign-count-inactive {
  font-family: Roboto !important;
  font-weight: 600 !important;
  font-style: Semi Bold !important;
  font-size: 11px !important;
  line-height: 16.5px !important;
  letter-spacing: 0px !important;
  text-align: center !important;
  color: #6a7282 !important;
}
.campaign-segment-label {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: 10px;
  width: 100%;
}

.campaign-ai-label {
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  gap: 6px;
}

.campaign-ai-label svg {
  flex-shrink: 0;
}

.campaign-segment-label .selectedCount {
  flex-shrink: 0;
}
.ai-suggestion-div {
  display: flex;
  align-items: center;
  margin-top: 20px;
  margin-right: 10px;
}
.re-designed-mobile-action-items {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.campaign-more-actions-mobile-container {
  width: 100%;
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  margin-top: 20px;
}

.campaign-more-actions-mobile {
  width: 100%;
  min-height: 5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  gap: 0.75rem;
  border-radius: 0.625rem;
  background: #fff;
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);
  text-align: center;
}
.re-designed-export-btn {
  background: var(--Icon-Default-Default, #ffffff) !important;
  border-top: 1px solid #d1d5dc !important;
  height: 38px !important;
  border-radius: 10px !important;
  border-width: 1px !important;
}
.redesigned-add-cart {
  height: 36px !important;
  border-radius: 10px !important;
  background: var(--Colors-Primary-500, #d2042d) !important;
  color: #fff !important;
}
@media (max-width: 1024px) {
  .re-designed-campaign-details-parent-div {
    width: 80% !important;
  }
  .re-campaign-overview-alignment-container {
    width: 20% !important;
  }
}
@media (max-width: 768px) {
  .re-designed-campaign-details-parent-div {
    width: 100% !important;
  }
  .common-main-header-text {
    font-size: 16px !important;
  }
}

@media (max-width: 425px) {
  .campaign-overview-section {
    flex-direction: column;
    gap: 20px;
  }
  .campaign-more-actions-div {
    height: 23% !important;
  }
  .no-data-card {
    width: 100% !important;
  }
}
/* .campaign-details-parent-div::-webkit-scrollbar {
  width: 8px;
}

.campaign-details-parent-div::-webkit-scrollbar-track {
  background: transparent;
}

.campaign-details-parent-div::-webkit-scrollbar-thumb {
  border-radius: 10px;
}
.campaign-details-parent-div {
  scrollbar-width: thin;
} */
`, "",{"version":3,"sources":["webpack://./src/components/common/campaigns/campaigndetails/CampaignDetails.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,kDAAkD;AACpD;;AAEA;EACE,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;AACA;EACE;IACE,YAAY;IACZ,WAAW;EACb;EACA;IACE,qBAAqB;IACrB,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;EACE;IACE,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;EACE;IACE,aAAa;IACb,8BAA8B;EAChC;AACF;;AAEA;EACE,2CAA2C;EAC3C,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,sCAAsC;EACtC,uBAAuB;EACvB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,oBAAoB;EACpB,iCAAiC;AACnC;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,2DAA2D;EAC3D,8BAA8B;EAC9B,UAAU;EACV,4BAA4B;EAC5B,oCAAoC;EACpC,sCAAsC;EACtC,qCAAqC;EACrC,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,gCAAgC;EAChC,0BAA0B;EAC1B,8BAA8B;EAC9B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,gDAAgD;EAChD,kBAAkB;AACpB;AACA;EACE,2DAA2D;EAC3D,wCAAwC;EACxC,uBAAuB;EACvB,8BAA8B;EAC9B,4BAA4B;AAC9B;AACA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,yDAAyD;EACzD,sBAAsB;AACxB;AACA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;AACA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;AACA;;;;;;;;;;;;;GAaG","sourcesContent":[".campaign-icons {\n  height: 40px;\n  width: 40px;\n  cursor: pointer;\n}\n.campaign-details-parent-div {\n  height: 80vh;\n  overflow-y: auto;\n}\n.campaign-overview-links {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  border-radius: 0.625rem;\n  background: #fff;\n  gap: 10px;\n  box-shadow: 2px 2px 13.1px 0px rgba(0, 0, 0, 0.05);\n}\n\n.recomended-products-div {\n  min-height: 200px !important;\n  max-height: 400px !important;\n  overflow-y: scroll;\n  padding-bottom: 16px;\n  box-sizing: border-box;\n}\n.recommended-products {\n  margin-top: 30px;\n}\n.campaign-more-actions-div {\n  display: flex;\n}\n.campaign-details-page-display {\n  display: flex;\n  justify-content: space-between;\n}\n\n.my-billboards-tab .ant-segmented.ant-segmented-sm .ant-segmented-item-label {\n  min-height: 20px;\n  line-height: 20px;\n  width: 236px;\n}\n.backarrow {\n  cursor: pointer;\n}\n\n@media (width <= 1440px) {\n  .campaign-icons {\n    height: 28px;\n    width: 28px;\n  }\n  .campaign-details-parent-div {\n    height: 72vh;\n    overflow-y: scroll;\n  }\n}\n\n@media (width <= 1024px) {\n  .campaign-icons {\n    height: 32px;\n    width: 32px;\n  }\n}\n@media (width <= 430px) {\n  .campaign-icons {\n    height: 24px;\n    width: 24px;\n  }\n  .middle-specification {\n    border-radius: 0.5rem;\n    align-items: center;\n  }\n  .my-billboards-tab {\n    margin-top: 0rem;\n    font-size: 12px;\n    width: 400px;\n    overflow-x: scroll;\n  }\n}\n@media (width <= 380px) {\n  .my-billboards-tab {\n    margin-top: 0rem;\n    font-size: 12px;\n    width: 350px;\n    overflow-x: scroll;\n  }\n}\n@media (width <= 768px) {\n  .campaign-overview-total-impressions {\n    display: flex;\n    flex-direction: row !important;\n  }\n}\n\n.product-expired-conatiner {\n  padding: 1.625rem 1.25rem 1.0625rem 1.25rem;\n  gap: 1.25rem;\n  border-radius: 0.625rem;\n  background: #fff;\n}\n.expired-product-warning {\n  color: var(--Colors-Text-500, #0a0f0d);\n  font-family: Montserrat;\n  font-size: var(--Font-Font-Size-h6, 1.1875rem);\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.prodcts-expired {\n  color: #000;\n  text-align: center;\n  font-family: Roboto;\n  font-size: 1rem;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.5rem;\n  margin-top: 10px;\n}\n.prodcts-expired-names {\n  font-family: Roboto;\n  font-weight: 400;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0%;\n  color: #000000;\n}\n\n.campaign-details-div {\n  display: flex;\n}\n\n.campaign-details-page-display {\n  width: 100%;\n  margin: 0;\n}\n\n.campaign-details-io-div {\n  gap: 1rem;\n  display: flex;\n}\n\n.campaign-details-io-cancel-div {\n  border-radius: 0.3125rem;\n  background: #f5f5f5;\n  width: 2.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 2.5rem;\n  cursor: pointer;\n}\n\n.product-expired-conatiner-row {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.re-designed-campaign-details-parent-div {\n  width: 85% !important;\n}\n.re-campaign-overview-alignment-container {\n  display: flex;\n  width: 15% !important;\n  gap: 20px !important;\n  flex-direction: column !important;\n}\n.my-billboards-tab .ant-segmented.ant-segmented-sm .ant-segmented-item-label {\n  min-height: 20px;\n  line-height: 20px;\n  width: 236px;\n  white-space: nowrap;\n}\n.campaign-segments.ant-segmented .ant-segmented-item-selected {\n  background: var(--Icon-Default-Default, #ffffff) !important;\n  border-radius: 10px !important;\n  opacity: 1;\n  border-width: 1px !important;\n  border: 1px solid #e5e7eb !important;\n  box-shadow: 0px 1px 2px -1px #0000001a;\n  box-shadow: 0px 1px 3px 0px #0000001a;\n  display: flex;\n  align-items: center;\n}\n.campaign-count-inactive {\n  font-family: Roboto !important;\n  font-weight: 600 !important;\n  font-style: Semi Bold !important;\n  font-size: 11px !important;\n  line-height: 16.5px !important;\n  letter-spacing: 0px !important;\n  text-align: center !important;\n  color: #6a7282 !important;\n}\n.campaign-segment-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n  gap: 10px;\n  width: 100%;\n}\n\n.campaign-ai-label {\n  display: inline-flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  white-space: nowrap;\n  gap: 6px;\n}\n\n.campaign-ai-label svg {\n  flex-shrink: 0;\n}\n\n.campaign-segment-label .selectedCount {\n  flex-shrink: 0;\n}\n.ai-suggestion-div {\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n  margin-right: 10px;\n}\n.re-designed-mobile-action-items {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.campaign-more-actions-mobile-container {\n  width: 100%;\n  display: flex;\n  gap: 10px;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n\n.campaign-more-actions-mobile {\n  width: 100%;\n  min-height: 5rem;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  padding: 20px;\n  gap: 0.75rem;\n  border-radius: 0.625rem;\n  background: #fff;\n  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.08);\n  text-align: center;\n}\n.re-designed-export-btn {\n  background: var(--Icon-Default-Default, #ffffff) !important;\n  border-top: 1px solid #d1d5dc !important;\n  height: 38px !important;\n  border-radius: 10px !important;\n  border-width: 1px !important;\n}\n.redesigned-add-cart {\n  height: 36px !important;\n  border-radius: 10px !important;\n  background: var(--Colors-Primary-500, #d2042d) !important;\n  color: #fff !important;\n}\n@media (max-width: 1024px) {\n  .re-designed-campaign-details-parent-div {\n    width: 80% !important;\n  }\n  .re-campaign-overview-alignment-container {\n    width: 20% !important;\n  }\n}\n@media (max-width: 768px) {\n  .re-designed-campaign-details-parent-div {\n    width: 100% !important;\n  }\n  .common-main-header-text {\n    font-size: 16px !important;\n  }\n}\n\n@media (max-width: 425px) {\n  .campaign-overview-section {\n    flex-direction: column;\n    gap: 20px;\n  }\n  .campaign-more-actions-div {\n    height: 23% !important;\n  }\n  .no-data-card {\n    width: 100% !important;\n  }\n}\n/* .campaign-details-parent-div::-webkit-scrollbar {\n  width: 8px;\n}\n\n.campaign-details-parent-div::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.campaign-details-parent-div::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n}\n.campaign-details-parent-div {\n  scrollbar-width: thin;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
